
export enum SortType {
    None = 0,
    Name = 1,
    NameDescending = 2,
    OriginalArtist = 3,
    OriginalArtistDecending = 4
}

export interface TrackInfo {
    name: string;
    original_artist: string;
}

export interface Track extends TrackInfo {
    id: number;
    file: string;
    original: false;
    lyrics:string;
};

export function SortTracks(tracks:Track[], orderBy:SortType) {
    switch (orderBy) {
        case SortType.Name:
            tracks.sort((a, b) => a.name.localeCompare(b.name));
            break;
        case SortType.NameDescending:
            tracks.sort((a, b) => a.name.localeCompare(b.name) * -1);
            break;
        case SortType.OriginalArtist:
            tracks.sort((a, b) => a.original_artist.localeCompare(b.original_artist));
            break;
        case SortType.OriginalArtistDecending:
            tracks.sort((a, b) => a.original_artist.localeCompare(b.original_artist) * -1);
            break;
    }
}

export enum MediaState {
    Stopped = 0,
    Loading = 1,
    Playing = 2,
    Paused = 3
}

export enum RepeatState {
    None = 0,
    Repeat = 1,
    RepeatOne = 2
}

export enum LoadState {
    None = 0,
    Loading = 1,
    Failed = 2,
    Success = 3
}

export const HAS_MEDIA_SESSION = window && window.navigator && 'mediaSession' in window.navigator;

/**
 * Get random integer between min and up to and not including max.
 * @param min minimum value
 * @param max maximum value
 * @returns 
 */
export function random(min: number, max: number): number {
    return min + Math.floor(Math.random() * (max - min));
}

export function clamp(value:number, min:number, max:number) {
    return Math.min(Math.max(value, min), max);
}


export const AUDIO_URL='https://bbbaudio.blob.core.windows.net/bbb/';
export const DATA_URL='https://bbbaudio.blob.core.windows.net/bbb/Data/';